import {
  RepeatingTask,
  TaskFilterOptions,
  Timestamp,
  User,
} from '@griply/types';
import { filterRepeatingTasks, getWeekStartsOn } from '@griply/utils';
import { useMemo } from 'react';

export type UseFilteredRepeatingTasksInput = {
  repeatingTasks: RepeatingTask[];
  filters: TaskFilterOptions | TaskFilterOptions[];
  today: Timestamp;
  user: User | null | undefined;
};

export const useFilteredRepeatingTasks = ({
  repeatingTasks,
  filters,
  today,
  user,
}: UseFilteredRepeatingTasksInput): RepeatingTask[] => {
  const weekStartsOn = getWeekStartsOn(user);

  return useMemo(() => {
    const filtersArray = Array.isArray(filters) ? filters : [filters];
    // dev-only timing (RN __DEV__ global) — slow lines mean the planning caches are missed
    const isRnDev = (globalThis as { __DEV__?: boolean }).__DEV__ === true;
    const t0 = isRnDev ? Date.now() : 0;
    const result = filterRepeatingTasks({
      repeatingTasks,
      filters: filtersArray,
      weekStartsOn,
      today,
    });
    if (isRnDev && Date.now() - t0 >= 3) {
      // eslint-disable-next-line no-console -- temporary perf instrumentation
      console.log(
        `[perf] ${t0 % 100000} filterRepeating ${Date.now() - t0}ms (${repeatingTasks.length}r ${filtersArray.length}f)`,
      );
    }
    return result;
  }, [filters, repeatingTasks, today, weekStartsOn]);
};
